<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :model="form" :inline="true" size="mini" ref="searchForm" label-width="85px">
        <el-form-item label="姓名">
          <el-input v-model.trim="form.userName" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="店铺">
          <el-select v-model="form.storeName" placeholder="请选择" @change="onSearch">
            <el-option v-for="item in storeList" :key="item.storeCode" :label="item.storeName" :value="item.storeName"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
        <el-button type="warning" size="small" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="small" @click="add">新增</el-button>
      </template>
      <el-table
        :data="tableData.list"
        ref="tableRef"
        border
        :height="maxTableHeight"
        :header-cell-style="{ textAlign: 'left' }"
        :cell-style="{ textAlign: 'left' }"
        v-loading="loading"
      >
        <el-table-column label="姓名" prop="userName" width="100"></el-table-column>
        <el-table-column label="工号" prop="workNo" width="150"></el-table-column>
        <el-table-column label="岗位" prop="workJobs" width="200"></el-table-column>
        <el-table-column label="店铺权限" prop="storeName" show-overflow-tooltip></el-table-column>
        <el-table-column label="更新人" prop="updatedPerson" width="100"></el-table-column>
        <el-table-column label="更新时间" prop="updatedDate" width="200"></el-table-column>
        <el-table-column label="操作" width="120px" align="center">
          <template slot-scope="scoped">
            <el-link type="primary" :underline="false" @click="edit(scoped.row)">编辑</el-link>
            <el-link type="primary" :underline="false" style="color: red" @click="delRow(scoped.row)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </template>
    </table-panel>

    <add-edit ref="content" :visible.sync="dialogVisible" :rowData="rowData" :authOptions="authOptions" @success="onSearch" v-if="dialogVisible"></add-edit>
  </div>
</template>

<script>
import axios from "@/utils/axiosInstance";
import addEdit from "./components/add&edit/add&edit";
import tableMixin from "@/utils/tableMixin";

export default {
  mixins: [tableMixin],
  components: { addEdit },
  data() {
    return {
      form: {
        storeName: '全部',
      },
      tableHeight: 0,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      dialogVisible: false,
      dialogConfig: {},
      rowData: {},
      storeList: [],
      queryCriteria: [],
      searchFormData: [],
      authOptions: [],
      loading: false,
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
    this.getStoreListEdit()
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "userName", //姓名
          val: this.form.userName ? this.form.userName : "",
          op: "like",
        },
        {
          attributeName: "storeName", //店铺
          val: this.form.storeName && this.form.storeName != '全部' ? this.form.storeName : "",
          op: "like",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = "qualityCheckTeamLeaderPrivilege";
      data.queryMatch = filter || [];
      data.hasCount = "Y";
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/qualityCheckTeamLeaderPrivilege`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.getStoreName()
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    // 重置
    reset() {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = 30;
      this.form = {
        storeName: '全部',
      };
      this.onSearch();
    },
    // 新增 弹出dialog
    add() {
      this.rowData = null;
      this.dialogVisible = true;
    },
    // 修改 弹出dialog
    edit(row) {
      this.rowData = row;
      this.dialogVisible = true;
    },
    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      let res = await this.$q.qualityTestingManage.teamLeaderDel({ fragment: [row.userId] });
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail("删除失败");
      }
      this.init();
    },
    //店铺
    getStoreName() {
      let data = { ...this.currencyForm };
      data.pageSize = this.tableData.pageSize;
      data.pageNum = this.tableData.pageNum;
      data.reportCode = "qualityCheckTeamLeaderPrivilegeStoreList";
      axios.post(`/ec-pc-api/custom/reports/data/qualityCheckTeamLeaderPrivilegeStoreList`, data).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list || []
        }
      });
    },
    //编辑弹窗内店铺
    getStoreListEdit() {
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm));
      currencyForm.reportCode = "storeInfoList";
      axios.post(`/ec-pc-api/custom/reports/data/storeInfoList`, currencyForm).then((res) => {
        if (res.code == 200) {
          this.authOptions = res.data.list;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
